module.exports = __webpack_public_path__ + "static/media/mare.f3b7cfb5.jpg";